<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span className="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/>  {{item.title.filter(obj => { return (obj.key == lang) })[0].value}} </span>
          </CCardHeader>
          <CCardBody>

            {{levels}}
            <CRow>
              <CCol col="6">
                <CChartRadar
                    :datasets="defaultDatasets"
                    :options="defaultOptions"
                    :labels="labels"
                />
                <CRow>
                  <CCol>
                    หมายเหตุ :
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <CIcon name="cil-star" size="lg" class="text-danger"/> = ต่ำกว่าระดับความคาดหวัง
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <CIcon name="cil-star" size="lg" class="text-success"/> = อยู่ในระดับความคาดหวัง
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <CIcon name="cil-star" size="lg" class="text-info"/> = สู่งกว่าระดับความคาดหวัง
                  </CCol>
                </CRow>
              </CCol>
              <CCol>
<!--                year-->
                <History :points="points" :item="item.item" :levels="levels"/>

              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import FilterOption from "@/projects/views/E-Performances/Estimate/components/FilterOption";
import Activitys from "@/projects/views/E-Performances/Estimate/components/Activitys";
import { CChartRadar } from '@coreui/vue-chartjs'
import History from "@/projects/views/E-Performances/Dashboard/users/components/Historys";
export default {
  name: 'EDCompetency',
  components: {History, Activitys, FilterOption, CChartRadar},
  props:{
    caption:{
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    year: {
      type: Number,
      default: 2566
    },
    levels: {
      type: Number,
      default: 4
    },
    item: {
      type: Object,
      default: {}
    },
    defaultDatasets:{
      type: Array,
      default: []
    },
    points:{
      type: Array,
      default: []
    }
  },
  data: function () {
    return {

      option:{
        organization: "66cbe802a41ed9362a8579fa",
        agency: "00000000000000000000000",
        year: new Date().getFullYear() + 543,
      },
      defaultOptions:{
        responsive: true,
        maintainAspectRatio: true,
        scale: {
          ticks: {
            beginAtZero: false,   // 🔥 สำคัญมาก
            min: 0,
            max: 5,              // หรือ 5 ตามระบบคุณ
            stepSize: 1
          },
          angleLines: {
            display: false
          },
          pointLabels: {
            fontSize: 12
          }
        }
      },
      labels:[]

    }


  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      for(var i=0; i<this.item.item.length; i++){
        var name = this.item.item[i].title.filter(obj => { return (obj.key == this.lang) })[0].value
        this.labels.push(name.split('-')[0].trim())
      }
    },

    onOptionChange(e){
      this.isShow = false;
      this.option = e;
    },

    onLoad(){

    }
  },



  computed:{
    ...mapGetters({
      lang : "setting/lang",
      userId:"auth/userId",
      // objsItem : "assessment/assessment",
      // objsProfile : "personal/profile",


      objsYourself : "estimate/yourself",
      objsHistory : "estimate/history",

    }),
  },

  watch: {

    objsYourself(value){

      console.log(value)
      // this.historys = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        objs.type = 0
        objs.year = item.year
        try {
          objs.code = item.accounts.accounts.code
        }catch (e) {

        }
        objs.info = item.accounts.accounts.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value +" "+item.accounts.accounts.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value+" "+ item.accounts.accounts.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        objs.position = item.position.agency.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value
        try {
          objs.status = item.status[item.status.length-1].state.title.filter(title => {
            if (title.key == lang) {
              return title
            }
          })[0].value
        }catch (e) {
          objs.status = item.status[item.status.length-1].state.title.filter(title => {
            if (title.key == "en") {
              return title
            }
          })[0].value
        }


        objs.value = item;
        // objs.historys = []

        items.push(objs)
      })
      this.item = items;
    },
  }

}
</script>
<style >

.four-pointed-star{
  position:relative;
  margin:1em auto;
  width:1em;
  font-size:12em;
}

.four-pointed-star:before{
  content:"";
  position:absolute;
  background:red;
  width:1em;
  height:1.15em;
  transform:rotate(-45deg) skewX(22.5deg) skewY(22.5deg);
}

.four-pointed-star:after{
  content:"";
  position:absolute;
  background:red;
  width:1em;
  height:1.15em;
  transform:rotate(45deg) skewX(22.5deg) skewY(22.5deg);
}
</style>


